import { Point } from '../../dictionary/geometry.types'

export interface GridSnapItem {
  id: string
  /** Top-left position relative to the item's parent. */
  position: Point
  /** Absolute top-left position of the parent. */
  parentPosition: Point
  width: number
  height: number
}

export function snapPointToGrid(point: Point, gridSize: number): Point {
  return {
    x: Math.round(point.x / gridSize) * gridSize,
    y: Math.round(point.y / gridSize) * gridSize,
  }
}

/**
 * Snap a dragged node/selection by its visual center, matching the legacy
 * canvas. Every item receives the same delta so group spacing is preserved.
 */
export function snapGroupCenterToGrid(items: GridSnapItem[], gridSize: number): Map<string, Point> {
  if (!items.length) {
    return new Map()
  }

  const left = Math.min(...items.map((item) => item.parentPosition.x + item.position.x))
  const top = Math.min(...items.map((item) => item.parentPosition.y + item.position.y))
  const right = Math.max(
    ...items.map((item) => item.parentPosition.x + item.position.x + item.width)
  )
  const bottom = Math.max(
    ...items.map((item) => item.parentPosition.y + item.position.y + item.height)
  )
  const center = { x: (left + right) / 2, y: (top + bottom) / 2 }
  const snappedCenter = snapPointToGrid(center, gridSize)
  const delta = { x: snappedCenter.x - center.x, y: snappedCenter.y - center.y }

  return new Map(
    items.map((item) => [item.id, { x: item.position.x + delta.x, y: item.position.y + delta.y }])
  )
}
